export interface SseMessage {
  event: string
  data: string
}

export interface ParsedSse {
  messages: SseMessage[]
  rest: string
}

/** Parse complete SSE frames and keep the trailing partial frame. */
export function parseSseBuffer(buffer: string): ParsedSse {
  const normalized = buffer.replace(/\r\n/g, '\n')
  const blocks = normalized.split('\n\n')
  const rest = blocks.pop() ?? ''
  const messages: SseMessage[] = []
  for (const block of blocks) {
    let event = 'message'
    const data: string[] = []
    for (const line of block.split('\n')) {
      if (line.startsWith(':')) continue
      const separator = line.indexOf(':')
      const field = separator === -1 ? line : line.slice(0, separator)
      let value = separator === -1 ? '' : line.slice(separator + 1)
      if (value.startsWith(' ')) value = value.slice(1)
      if (field === 'event') event = value
      if (field === 'data') data.push(value)
    }
    if (data.length > 0) messages.push({ event, data: data.join('\n') })
  }
  return { messages, rest }
}
